
import React, { useEffect } from 'react';
import { Header } from "@/components/Header";
import { FooterSection } from "@/components/FooterSection";
import TransactionsContent from "@/components/expertise/TransactionsContent";

const Transactions = () => {
  useEffect(() => {
    document.title = "AI Commercial Transaction Management | DocketLabs";
    
    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'AI commercial transaction management. Streamline due diligence, deal management & documentation. Accelerate your deals.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'AI commercial transaction management. Streamline due diligence, deal management & documentation. Accelerate your deals.';
      document.getElementsByTagName('head')[0].appendChild(meta);
    }
  }, []);

  return (
    <>
      <Header />
      <div className="pt-24 bg-background min-h-screen">
        <TransactionsContent />
      </div>
      <FooterSection />
    </>
  );
};

export default Transactions;
